import React from "react";
import styled from "styled-components";

import imagemFundo from "../../images/imagemfundo.png";

import menu from "../../images/menu.png";

import minhascotas from "../../images/MinhasCotas.png";
import meusInteresses from "../../images/meusInteresses.png";
import Globais from "../../css/Globais";

const Container = styled.section`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: #fff;
  opacity: 80%;
  button {
    border: none;
    width: 8%;
    background: transparent;
    &:hover {
      cursor: pointer;
    }
  }
`;
const Imagem = styled.img`
  background-repeat: no-repeat;
  background-position: center;
  width: 90%;
  @media (min-width: 500px) {
    width: 70%;
  }

  @media (min-width: 600px) {
    width: 50%;
  }
  @media (min-width: 700px) {
    width: 30%;
  }
  @media (min-width: 900px) {
    width: 20%;
  }
`;

const ContainerTermo = styled.div`
  width: 100%;
  height: 100%;
  max-width: 80rem;
  min-width: 15rem;
  min-height: 30rem;
  justify-self: flex-start;

  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
  background-color: #fff;
  border-radius: 30px;
  position: absolute;
  z-index: 0;
  display: grid;
  grid-template: 10% 90%/ 100%;
  justify-content: center;
  aligm-itens: center;
  @media (min-height: 1000px) {
    height: 70%;
  }
`;

const TextWrapper = styled.div`
  display: flex;

  justify-content: flex-start;

  margin-left: 2rem;
  margin-right: 2rem;
  overflow: auto;

  flex-direction: column;
  @media (min-width: 450px) {
    margin-left: 5rem;
    margin-right: 5rem;
  }
  #text {
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
  }
  #button {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #voltar {
    diplay: grid;
    grid-template: 50% 50% / 100%;
    align-items: center;
    justify-content: center;
  }
`;

const ContainerTitulo = styled.div`
  width: 100%;

  height: 100%;
  display: flex;
  justify-content: center;
`;

const Titulo = styled.h1`
  text-align: center;
  align-self: center;
  color: ${Globais.CorAzulBackGround};
  font-size: 1.2rem;
  width: 80%;
  margin-top: 3rem;
  margin-bottom: 3rem;
  @media (min-width: 400px) {
    font-size: 1.5rem;
  }
  @media (min-width: 700px) {
    font-size: 1.8rem;
  }
`;

const H3 = styled.h3`
  text-align: left;

  color: ${Globais.CorAzulBackGround};
  font-size: 1rem;

  @media (min-width: 400px) {
    font-size: 1.2rem;
  }
`;
const H3Details = styled.h3`
  text-align: left;
  margin-left: 5rem;

  color: ${Globais.CorAzulBackGround};
  font-size: 1rem;
  @media (min-width: 400px) {
    font-size: 1.2rem;
  }
`;

export default function ViewPrimeiraVezPosCadastroPessoais() {
  return (
    <Container>
      <Imagem src={imagemFundo} alt="" />
      <ContainerTermo>
        <ContainerTitulo>
          <Titulo>SEJA BEM-VINDO AO MULTICOTAS!</Titulo>
        </ContainerTitulo>

        <TextWrapper>
          <H3>
            <br />
            <p>Vamos aos primeiros passos:</p>
            <br />
            <p>
              Se você é cotista primeiro deve cadastrar sua cota, para isso:
            </p>
          </H3>
          <H3Details>
            <p>1º Abra o menu que fica no canto superior esquerdo:</p>
            <p>
              {" "}
              <Imagem src={menu}></Imagem>
            </p>{" "}
            <p> 2º Clique na opção "Minhas Cotas":</p>
            <Imagem src={minhascotas}></Imagem>
          </H3Details>

          <H3>
            <p>
              {" "}
              Se você não é cotista e deseja alugar algum período, siga esses
              passos:{" "}
            </p>
          </H3>

          <H3Details>
            <p>1º Abra o menu que fica no canto superior esquerdo:</p>
            <p>
              {" "}
              <Imagem src={menu}></Imagem>
            </p>{" "}
            <p> 2º Clique na opção "Meus Interesses":</p>
            <Imagem src={meusInteresses}></Imagem>
          </H3Details>
        </TextWrapper>
      </ContainerTermo>
    </Container>
  );
}
